// import axios from "axios";
// import Cookies from "js-cookie";
// export const baseURL = process.env.NODE_ENV === "development" ? "http://localhost:4000" : "https://backend.wyntersdreams.com";
export const baseURL = "https://backend.wyntersdreams.com";
// export const baseURL = "http://localhost:4000";
// export const baseURL = "https://c3a6-2401-4900-1c18-1dd7-c9e5-346-659d-a98c.ngrok-free.app";


// const axiosInstance = axios.create({
//   baseURL: baseURL,
//   // headers: Cookies.get("authToken") && Cookies.get('authToken') !== 'undefined' ? {
//   //   Authorization: `Bearer ${Cookies.get('authToken')}`
//   // } : undefined
// });

// export default axiosInstance;
